import React, { useState, useEffect } from 'react'
import { Card, Col, Container } from 'reactstrap'
// actions
import { getCustomers, updateCustomer, addNewCustomer, deleteCustomer, updateCustomerStatus } from "../../../store/catalogs/Customers/actions"
import { useSelector, useDispatch } from "react-redux";
import { CustomerRegisterModal } from './CustomerRegisterModal';

import Table1 from "../../../components/Common/TableContainer"
import { SearchBar } from '../../../components/Common/SearchBar'
import { BackButton } from '../../../components/Common/BackButton'
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton'
import Breadcrumb from '../../../components/Common/Breadcrumb'
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal'
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"


const CatalogLayoutCustomers = (props) => {

    // * Redux
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getCustomers("?limit=20&page=0"))
    }, [])

    const { customers, loading, total, currentPage } = useSelector(state => ({
        customers: state.customersReducer.customers,
        loading: state.customersReducer.loading,
        customer: state.customersReducer.customer,
        total: state.customersReducer.total,
        currentPage: state.customersReducer.currentPage
    }));
    // * Redux fin

    // Modal HOOKS
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [searchData, setSearchData] = useState('');

    useEffect(() => {
        dispatch(getCustomers(`?limit=20&page=0&search=${searchData}`))
    }, [searchData])

    const onUpdate = (values) => {
        setIsUpdate(true)
        setRowInfo(values)
        setShowModal1(true)
    }

    const onDelete = (values) => {
        setRowInfo(values)
        setShowModal2(true)
    }

    const reRender = () => {
        dispatch(getCustomers("?limit=20&page=0"))
    }

    const RegisterModalRespInfo = (values, active) => {
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id }
            dispatch(updateCustomer(updValue))
            dispatch(updateCustomerStatus({
                id: rowInfo.id,
                recordStatus: active,
            }));
        } else {
            dispatch(addNewCustomer(values))
        }
        setTimeout(reRender, 1000);
        setIsUpdate(false)
        setRowInfo('')
    }

    const modalClose = () => {
        setIsUpdate(false)
    }

    const onDeleteConfirmation = () => {
        dispatch(deleteCustomer(rowInfo))
        setTimeout(reRender, 500);
        setRowInfo('')
    }

    const getPagination = (params) => {
        dispatch(getCustomers(`${params}&search=${searchData}`))
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'Cliente',
                width: '20%',
                Cell: ({ row }) => (
                    <div className='text-center'>{row.original.name}</div>
                ),
            },
            {
                Header: 'Dirección',
                width: '18%',
                Cell: ({ row }) => (
                    <div className='text-center'>{row.original.address}</div>
                ),
            },
            {
                Header: 'Tipo de Cliente',
                width: '18%',
                Cell: ({ row }) => (
                    <div className='text-center'>{row.original.customerType}</div>
                ),
            },
            {
                Header: 'Correo Electrónico',
                width: '12%',
                Cell: ({ row }) => (
                    <div className='text-center'>{row.original.email}</div>
                ),
            },
            {
                Header: 'Teléfono Asesor Técnico',
                width: '12%',
                Cell: ({ row }) => (
                    <div className='text-center'>{row.original.phone}</div>
                ),
            },
            {
                Header: 'Estatus',
                width: '15%',
                Cell: ({ row }) => (
                    row.original.recordStatus == true ?
                        <div className='text-success'>Activo</div> :
                        <div className='text-danger'>Inactivo</div>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0 me-2" onClick={() => { onUpdate(row.original) }}>
                            <span className="mdi mdi-18px mdi-lead-pencil p-2"></span>
                        </button>
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0" onClick={() => { onDelete(row.original) }}>
                            <span className="mdi mdi-18px mdi-delete p-2"></span>
                        </button>
                    </div>
                ),
            },
        ],
        []
    )

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 20 }}>
                        <Card className='' style={{ padding: 50 }}>

                            <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='CustomersCatalog' />

                            <div className='pe-1'>
                                <BackButton props={props} />
                            </div>

                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9col-xxl-9 mb-2 ps-3 pe-3">
                                    <SearchBar setSearchData={setSearchData} />
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 pe-3">
                                    <NewRegisterButton setShowModal={setShowModal1} showModal={showModal1} />
                                </div>
                            </div>

                            <div className='ms-1'>
                                <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={customers} />
                            </div>

                            <CustomerRegisterModal
                                rowInfo={rowInfo}
                                isUpdate={isUpdate}
                                modalRespInfo={RegisterModalRespInfo}
                                setShowModal={setShowModal1}
                                showModal={showModal1}
                                modalClose={modalClose}
                            />

                            <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar clientes' modalBodyLabel={'¿Está seguro que desea eliminar el cliente seleccionado?'} />
                            <br />

                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />
                </Container>
            </div>
        </React.Fragment>
    )
}
export default CatalogLayoutCustomers